import { useEffect, useState } from 'react'

import { getQuestDetailsApi } from '@api'

import { QuestId } from './questId'

export const useQuestCurrentStage = (questId: QuestId, enabled = true) => {
  const [currentStage, setCurrentStage] = useState<number | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!enabled) return;
    setIsLoading(true)
    getQuestDetailsApi(questId).then(({ ok, data }) => {
      if (ok && data) {
        setCurrentStage(data.current_part)
      }
      setIsLoading(false)
    })
  }, [questId, enabled])

  return { currentStage, isLoading }
}
